import { FormContainer } from "./form-container";
import { OfflineStatus } from "@rumble-it/common-components/components/OfflineStatus";

export const DealerIntakeForm = () => {
  // TODO: Move all logic related to fetching data for the DealerIntakeForm here,
  // so that the FormContainer is only responsible for rendering the form and the form state,
  // independent of whether it is for the widget or the dealer intake form.
  return (
    <>
      <div className="flex flex-col items-center mb-8">
        <OfflineStatus />

        <div className="rounded-lg min-w-[800px]">
          <FormContainer
            formType="repair-direct-generic-dealer-intake"
            formSchemaKey="form"
          />
        </div>
      </div>
    </>
  );
};

export default DealerIntakeForm;
